import React, { useState, useRef, useEffect } from 'react';
import { useVenue } from '../../context/VenueContext';
import { MapPin, ChevronDown, Check } from 'lucide-react';

export default function VenueSelector() {
  const { venues, activeVenue, activeVenueId, switchVenue, isMultiVenue } = useVenue();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  if (!activeVenue) return null;

  if (!isMultiVenue) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 text-xs text-[#64748B]" data-testid="venue-indicator">
        <MapPin size={13} className="text-[#D44E20] flex-shrink-0" />
        <span className="truncate">{activeVenue.name}</span>
      </div>
    );
  }

  return (
    <div className="relative px-3 mb-2" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        data-testid="venue-selector-btn"
        className="w-full flex items-center gap-2 px-3 py-2.5 rounded-xl border border-slate-200 bg-slate-50 hover:bg-white hover:border-[#D44E20]/30 transition-all text-left group"
      >
        <MapPin size={14} className="text-[#D44E20] flex-shrink-0" />
        <span className="flex-1 text-xs font-medium text-[#1A1A1A] truncate">{activeVenue.name}</span>
        <ChevronDown size={14} className={`text-[#94A3B8] transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute left-3 right-3 top-full mt-1 bg-white rounded-xl border border-slate-200 shadow-lg z-50 py-1 max-h-60 overflow-y-auto" data-testid="venue-dropdown">
          {venues.map(v => (
            <button
              key={v.id}
              onClick={() => { switchVenue(v.id); setOpen(false); }}
              data-testid={`venue-option-${v.id}`}
              className={`w-full flex items-center gap-2 px-3 py-2.5 text-left text-xs transition-colors ${
                v.id === activeVenueId
                  ? 'bg-[#FDECE7] text-[#D44E20] font-medium'
                  : 'text-[#1A1A1A] hover:bg-slate-50'
              }`}
            >
              <MapPin size={12} className={v.id === activeVenueId ? 'text-[#D44E20]' : 'text-[#94A3B8]'} />
              <div className="flex-1 min-w-0">
                <p className="truncate">{v.name}</p>
                {v.address?.full && <p className="text-[10px] text-[#94A3B8] truncate">{v.address.full}</p>}
              </div>
              {v.id === activeVenueId && <Check size={14} className="text-[#D44E20] flex-shrink-0" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
